import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ModalHeader } from 'reactstrap';
import { useIntl } from 'react-intl';

const AccessModalHeader = ({ addingTemplate, linkSettingsOpen, handleClose }) => {
  const intl = useIntl();

  return (
    <ModalHeader
      toggle={handleClose}
      className={classnames('modal-header-center', { 'modal-header-editing-mode': addingTemplate })}
    >
      <div className="modal-header-wrapper">
        {
          linkSettingsOpen ?
            intl.formatMessage({ defaultMessage: 'Link settings' }) :
            intl.formatMessage({ defaultMessage: 'Access & Share' })
        }
      </div>
    </ModalHeader>
  );
};

AccessModalHeader.propTypes = {
  addingTemplate: PropTypes.bool,
  linkSettingsOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

AccessModalHeader.defaultProps = {
  addingTemplate: false,
};

export default AccessModalHeader;
